import { NewsActions, NewsEditRequest } from "../domain/news";
import { editNewsService } from "../infrastructure/services/editNewsService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const editNews = {
  async execute(
    title: string,
    body: string,
    image1: File | null,
    shortTitle: string
  ): Promise<void> {
    const request: NewsEditRequest = await NewsActions().editNewsRequest(
      title,
      body,
      image1,
      shortTitle,
      image1 !== null
    );
    await editNewsService.execute(await tokenValidation.execute(), request);
  },
};
